export const UPDATE_ACTIVEPAGE = "UPDATE_ACTIVEPAGE";
export const GLOBAL_USERS = "GLOBAL_USERS";
